import React from 'react'
import { useValue } from '@morningtrain/react-resources'

export default function KpiRangeValue ({ children, name, lowerLimitName, upperLimitName }) {
  const lowerLimit = useValue(lowerLimitName)
  const upperLimit = useValue(upperLimitName)

  const value = useValue(name)

  let color = 'black'

  if (value < lowerLimit) {
    color = 'red'
  } else if (value > upperLimit) {
    color = 'green'
  } else {
    color = 'yellow'
  }

  return React.Children.map(children, (child, i) => React.cloneElement(child, { color: color }))
}
